export const convertEventToError = (event: string): string => `Error:${event}`;
export const convertEventToEstimateEvent = (event: string): string => `Estimated:${event}`;
